import React from 'react';
import {NavLink, Link} from 'react-router-dom'; /* gives a class of active to the current link*/

let Header = (props) => {
    return (
        <header id="header">
        <div className="container">
          <nav>
            <Link to="/" className="logo"><i className="fas fa-exclamation-triangle"></i>TOP 10 CVE Dashboard</Link>
            <ul className="reports">
              <li><NavLink to="/">ALL</NavLink></li>
              <li><NavLink to="/cves/severity/HIGH">HIGH</NavLink></li>
              <li><NavLink to="/cves/severity/MEDIUM">MEDIUM</NavLink></li>
              <li><NavLink to="/cves/severity/LOW">LOW</NavLink></li>
            </ul>
          </nav>
        </div>
      </header>
    )
}

export default Header;